import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import map from 'lodash/map';
export default {
  name: 'NiotaClassicDevicesMultipleEditForm',
  mixins: [formMixin],
  props: {
    editAllFormDialog: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedRows: {
      type: Array,
      required: false,
      default: undefined
    },
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    applications: {
      type: Array,
      required: false,
      default: new Array()
    }
  },
  data: function () {
    return {
      formValid: false,
      formSaving: false,
      devices: null,
      deletePrompt: false,
      isActility: false,
      deviceIds: [],
      formItem: {
        adr_limit: null,
        tile_name: null,
        applicationId: null,
        deviceTypeId: null,
        properties: {
          minimum_packets_threshold: null,
          battery_alert_level: null,
          battery_warning_level: null,
          operational_status: {
            text: null,
            value: null
          },
          critical_time_without_package_level: {
            time: null,
            unit: {
              text: null,
              value: null
            }
          }
        }
      },
      adrLimits: [{
        id: '-',
        title: this.$i18n_t('NiotaClassic.Devices.form.resetAdrLimit')
      }, {
        id: '0',
        title: 'SF 12 / BW 125 MHz'
      }, {
        id: '1',
        title: 'SF 11 / BW 125 MHz'
      }, {
        id: '2',
        title: 'SF 10 / BW 125 MHz'
      }, {
        id: '3',
        title: 'SF 9 / BW 125 MHz'
      }, {
        id: '4',
        title: 'SF 8 / BW 125 MHz'
      }, {
        id: '5',
        title: 'SF 7 / BW 125 MHz'
      }, {
        id: '6',
        title: 'SF 7 / BW 250 MHz'
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    buttons() {
      return [{
        text: this.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.deleteButton'),
        color: this.color,
        emit: 'delete'
      }];
    }
  },
  watch: {
    selectedRows() {
      this.devices = cloneDeep(this.selectedRows);
    },
    devices(newVal) {
      this.filterDevicesForActility(newVal);
    }
  },
  created() {
    this.devices = cloneDeep(this.selectedRows);
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.devices = cloneDeep(this.selectedRows);
      this.filterDevicesForActility(this.devices);
    },
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    updateFormData(item, value) {
      set(this.formItem, item, value);
    },
    save() {
      this.setUpdateData();
      this.devicesUpdate();
      this.formValid = true;
      this.formSaving = true;
    },
    devicesUpdate() {
      NiotaClassicApiService.devicesUpdate(this.devices).then(res => {
        if (!res.data.err) {
          this.$snack(`${this.$i18n_t('NiotaClassic.Devices.snacks.updateSuccessful')} (${res.data.count}) ${this.$i18n_t('NiotaClassic.Devices.form.devices')}`, 'success');
          this.devices = res.data.devices;
          this.$emit('close');
          this.$emit('refreshList');
        } else {
          this.$snack(res.data.err, 'error');
          this.$emit('close');
        }
      }).catch(error => {
        if (get(error, 'response.data.err')) {
          this.$snack(get(error, 'response.data.err'), 'error');
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.updateFailed'), 'error');
        }
      });
    },
    setUpdateData() {
      this.devices = this.devices.map(device => {
        let keys = Object.keys(this.formItem);
        keys.forEach(key => {
          if (key === 'adr_limit' && this.formItem[key] === '-') {
            set(device, key, null);
          } else {
            if (this.formItem[key] !== null && key !== 'properties') {
              set(device, key, this.formItem[key]);
            }
          }
          if (key === 'properties') {
            if (get(this.formItem, 'properties.minimum_packets_threshold')) {
              set(device, 'properties.minimum_packets_threshold', get(this.formItem, 'properties.minimum_packets_threshold'));
            }
            if (get(this.formItem, 'properties.battery_alert_level')) {
              set(device, 'properties.battery_alert_level', get(this.formItem, 'properties.battery_alert_level'));
            }
            if (get(this.formItem, 'properties.battery_warning_level')) {
              set(device, 'properties.battery_warning_level', get(this.formItem, 'properties.battery_warning_level'));
            }
            if (get(this.formItem, 'properties.operational_status.value')) {
              set(device, 'properties.operational_status', get(this.formItem, 'properties.operational_status'));
            }
            if (get(this.formItem, 'properties.critical_time_without_package_level.time')) {
              set(device, 'properties.critical_time_without_package_level', get(this.formItem, 'properties.critical_time_without_package_level'));
            }
          }
        });
        return device;
      });
    },
    updateList(list) {
      this.devices = list;
    },
    remove() {
      this.getDeviceIds();
      this.removeDevices();
      this.deletePrompt = false;
    },
    removeDevices() {
      NiotaClassicApiService.devicesDelete(this.deviceIds.join()).then(res => {
        if (!res.data.err) {
          this.$snack(`${this.$i18n_t('NiotaClassic.Devices.snacks.deleteSuccessful')} (${res.data.count}) ${this.$i18n_t('NiotaClassic.Devices.form.devices')}`, 'success');
          this.devices = res.data.devices;
          this.$emit('refreshList');
        } else {
          this.$snack(res.data.err, 'error');
        }
      }).catch(error => {
        if (get(error, 'error.response.data.err')) {
          this.$snack(error.response.data.err, 'error');
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.deleteFailed'), 'error');
        }
      });
    },
    getDeviceIds() {
      this.deviceIds = map(this.devices, 'id');
    },
    filterDevicesForActility(devices) {
      let actilityObj = devices.find(item => get(item, 'originator.type').toLowerCase() === 'actility');
      this.isActility = actilityObj !== undefined;
    }
  }
};